import { gsap, ScrollTrigger } from "./globals.js";

document.addEventListener("DOMContentLoaded", () => {
	// IMAGE PARALLAX
	const imageText = document.querySelector('.image-text__img img');
	if (imageText) {
	  gsap.fromTo(imageText, {
	    y: '-30%',
	  }, {
	    y: () => `30%`,
	    ease: 'power2.out',
	    ease: 'none',
	    scrollTrigger: {
	      trigger: '.image-text',
	      start: 'top bottom',
	      end: 'bottom top',
	      scrub: true,
	    }
	  });
	}
});
